import React, { useEffect, useState } from "react";
import SingleCourseThree from "../../components/Course/SingleCourseThree";
import SectionTitle from "../../components/SectionTitle";
import axios from "axios";
import { SERVER_URL } from "../../api/url";

const CourseGridMain = ({ name }) => {
  const [loading, setLoading] = useState(false);
  const [coursesData, setCoursesData] = useState([]);

  useEffect(() => {
    fetchCourses(name);
  }, [name]);

  const fetchCourses = async (category) => {
    setLoading(true);
    try {
      const response = await axios.get(`${SERVER_URL}/course`, {
        params: {
          type: category,
          page: 1,
          limit: 100,
        },
      });

      const fetchedCourses = response?.data?.data?.currentDatas || [];
      setCoursesData(fetchedCourses);
    } catch (err) {
      console.error("Error fetching courses:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="react-course-filter back__course__page_grid pb---40 pt---110">
      {!loading && (
        <div className="container pb---70">
          {coursesData.length === 0 ? (
            <div className="course-message">
              <p className="no-courses">There are no available courses</p>
            </div>
          ) : (
            <>
              <div className="row mb-5">
                <SectionTitle Title={`${name}`} />

                <div className="course-card-container">
                  {coursesData.map((course, index) => (
                    <div key={index} className="course-card">
                      <SingleCourseThree course={course} name={name}/>
                    </div>
                  ))}
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default CourseGridMain;